import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { OfferViewDTO } from '../../../../../../models/offer-view-dto.type';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { UploadPricingHowToComponent } from '../../../../ui';
import { TranslateDirective } from '../../../../../../directives/translate.directive';

@Component({
  selector: 'jhi-bary-modal-pricing-how-to',
  templateUrl: './bary-modal-pricing-how-to.component.html',
  styleUrls: ['./bary-modal-pricing-how-to.component.scss'],
  standalone: true,
  imports: [UploadPricingHowToComponent, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaryModalPricingHowToComponent {
  readonly #modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public offer!: OfferViewDTO;

  @Output() closeEvent = new EventEmitter();

  public handleClick(): void {
    this.#modalRef.hide();
  }
}
